export default {
  install: (app, store) => {
    const pushEvent = (event) => {
      event = {
        ...event,
        site: 'digital sales',
        locale: store.locale,
        market: store.market,
        siteSection: 'public',
      };
      window.adobeDataLayer.push(event);
    };

    app.config.globalProperties.$adobeEvent = pushEvent;
    app.provide('adobeEvent', pushEvent );
  },
};
